import { DOCUMENT } from '@angular/common';
import { Renderer2,Component, OnInit,Inject  } from '@angular/core';
import { AccesoRequest } from 'src/app/modal/niubiz/acceso-request';
import { AccesoResponse } from 'src/app/modal/niubiz/acceso-response';
import { PrepagoConceptoRequest } from 'src/app/modal/niubiz/prepago-concepto-request';
import { ExternosService } from 'src/app/service/externos/externos.service';
import {NiubizService} from 'src/app/service/niubiz/niubiz.service';
import { environment } from "src/environments/environment";
import { DOMParser } from 'xmldom';

declare var payform: any;
@Component({
  selector: 'app-niubiz',
  templateUrl: './niubiz.component.html',
  styleUrls: ['./niubiz.component.scss']
})
export class NiubizComponent implements OnInit {
   accesoRequest:AccesoRequest;
   accesoResponse:AccesoResponse;

  // amount: string = '100.00';
  // channel: string = 'web';
  // countable: boolean = true;
  // purchaseNumber: string = '2020100901';
  dataPago:any;
  baseURL=environment.urlBase;
  // cardNumber: any;
  // cardExpiry : any;
  // cardCvc : any;

  // token: string = '';

  constructor(  
    private niubizService:NiubizService,
    private externosService:ExternosService,
  ) {
    //this.obtenerAccesoPago();
    
  }
 
  // private async generarTokenSeguridad(): Promise<void> {
  //  // console.log("confi "+JSON.stringify(this.generarConfiguracion()));
  //   payform.setConfiguration(this.generarConfiguracion());
  //   this.generarFormulario();
  // }
 
  // private obtenerEstilos() {
  //   return {
  //     'base': {
  //       'color': '#666666',
  //       'fontWeight': 700,
  //       'fontFamily': "'Montserrat', sans-serif",
  //       'fontSize': '16px',
  //       'fontSmoothing': 'antialiased',
  //       'placeholder': {
  //         'color': '#999999',
  //       },
  //       'autofill': {
  //         'color': '#e39f48',
  //       },
  //     },
  //     'invalid': {
  //       'color': '#E25950',
  //       '::placeholder': {
  //         'color': '#FFCCA5',
  //       },
  //     },
  //   }
  // }
  
  // private generarFormulario() {

  //   this.cardNumber = payform.createElement('card-number', {
  //       style: this.obtenerEstilos(), placeholder: 'Número de tarjeta'
  //     } , 'txtNumeroTarjeta');

  //   this.cardNumber.then(element => {

  //     // element.on('bin', function (data) {
  //     //   console.log('BIN: ', data);
  //     // });

  //     element.on('bin', (data) => {
  //       console.log('BIN: ', data);
  //     });

  //     element.on('change', function (data) {
  //       console.log('CHANGE: ', data);
  //     });

  //     element.on('dcc', function (data) {
  //       console.log('DCC: ', data);
  //     });

  //     element.on('installments', function (data) {
  //       console.log('INSTALLMENTS: ', data);
  //     });

  //     element.on('lastFourDigits', function (data) {
  //       console.log('LAST 4 DIGITS: ', data);
  //     });

  //   });

  //   this.cardExpiry = payform.createElement('card-expiry', {
  //       style: this.obtenerEstilos(), placeholder: 'MM/YY'
  //     }, 'txtFechaVencimiento');

  //   this.cardExpiry.then(element => {
  //     element.on('change', function (data) {
  //       console.log('CHANGE: ', data);
  //     });

  //   });

  //   this.cardCvc = payform.createElement('card-cvc', {
  //       style: this.obtenerEstilos(), placeholder: 'CVC'
  //     }, 'txtCvv');

  //   this.cardCvc.then(element => {
  //     element.on('change', function (data) {
  //       console.log('CHANGE: ', data);
  //     });

  //   });

  // }

  // private generarConfiguracion() {
  //   return {
  //     'callback': '',
  //     'sessionkey': this.accesoResponse.tokenSesion,
  //     'channel': this.channel,
  //     'merchantid': this.accesoResponse.merchantId,
  //     'purchasenumber': this.purchaseNumber,
  //     'amount': this.amount,
  //     'language': 'es',
  //     'font': 'https://fonts.googleapis.com/css?family=Montserrat:400&display=swap'
  //   }
  // }

  obtenerAccesoPago(){
    this.accesoRequest = new AccesoRequest();
    this.accesoRequest.email="bryanlarachiroque@gmail.com";
    this.accesoRequest.documentoCliente="70168846";
    this.accesoRequest.importe=100;
    this.niubizService.obtenerAcceso(this.accesoRequest).subscribe(data=>{
      this.accesoResponse = data;
      //this.generarTokenSeguridad();
      // console.log(this.accesoResponse);
      
    })

  }

 
  // pagar() {  
  //   console.log("Inico Pago");
  //   const data = {
  //     name: 'INTEGRACIONES',
  //     lastName: 'NIUBIZ',
  //     email: 'integraciones.niubiz@necomplus.com',
  //     alias: 'NCP'
  //   };
  //   try {
  //     console.log("Proceso de crearToken PayForm");
  //     const response = payform.createToken([this.cardNumber,this.cardExpiry,this.cardCvc], data);
  //     console.log("Respuesta: "+JSON.stringify(response));
  //     console.log("Respuesta token: "+response['transactionToken']);

  //     // this.globalService.crearAutorizacion(this.token, this.generarAutorizacion(response['transactionToken'])).subscribe(
  //     //   res => {
  //     //     console.log(res);
  //     //   }
  //     // );
  //   } catch(error) {
  //     console.log(error);
  //   }
  
  // }

  buscarDNI(){
    this.externosService.obtenerDatosXML("70168846").subscribe(data=>{
      // console.log("data",data);
      let obj  = JSON.parse(data);
      // console.log(obj.Result.ApellidoMaterno);
       
    });
  }

  cargarPrepagoNiubiz() {

    // console.log("-------------------------")
    // console.log("---ESTOY AQUI----")
    // console.log("-------------------------")
    let prepagoConceptoRequest:PrepagoConceptoRequest=new PrepagoConceptoRequest();


    prepagoConceptoRequest.codigoCliente="1001";
    prepagoConceptoRequest.codigocomercio="456879852"; //COD EDITORA PERÚ
    prepagoConceptoRequest.correoCliente="bryanlarachiroque@outlook.com";
    prepagoConceptoRequest.idpagoelectronico=40000001;
    prepagoConceptoRequest.ip="172.16.88.209";
    prepagoConceptoRequest.mensaje="OK";
    prepagoConceptoRequest.nroDocumentoCliente="70168846";
    prepagoConceptoRequest.resultado=1;
    prepagoConceptoRequest.tipoDocumentoCliente="DNI";
    prepagoConceptoRequest.totalpagar=100;
    prepagoConceptoRequest.urljsgenerarboton="https://static-content-qas.vnforapps.com/env/sandbox/js/checkout.js?qa=true";

    this.niubizService
      .registrarPrePagoConceptoPago(
        prepagoConceptoRequest    
      )
      .subscribe(
        (response) => {
          if (response.resultado == 1) { //CONSULTAR EN EL SERVICIO SI ES 1 O X
            
            this.dataPago = response.dato;
            // if (response.dato2?.actionCode == "000") {


              let form = document.createElement("form");
              form.setAttribute("method", "post");
              form.setAttribute(
                "action",
                this.baseURL +
                "api/pago-concepto/obtener-token-sesion-pasarela"+
                "?amount=" +
                response.dato.totalpagar +
                "&purchasenumber=" +
                response.dato.idpagoelectronico
              );
      
              form.setAttribute("id", "boton_pago");
              document.getElementById("btn_pago").appendChild(form);
              let scriptEl = document.createElement("script");
              scriptEl.setAttribute("src", response.dato.urljsgenerarboton);
              scriptEl.setAttribute("data-formbuttoncolor", "#4341a6");
              scriptEl.setAttribute(
                "data-sessiontoken",
                response.dato.sesionkey.sessionKey
              );
              scriptEl.setAttribute(
                "data-merchantid",
                response.dato.codigocomercio
              );
              scriptEl.setAttribute(
                "data-merchantlogo",
                "http://localhost:4200/assets/image/editora_logo.png"
              );
              scriptEl.setAttribute(
                "data-purchasenumber",
                response.dato.idpagoelectronico
              );
              scriptEl.setAttribute("data-channel", "web");
              scriptEl.setAttribute("data-expirationminutes", "5");
              scriptEl.setAttribute("data-amount", response.dato.totalpagar);
              scriptEl.setAttribute(
                "data-timeouturl",
                this.baseURL + "api/pago-concepto/timeout-pago"
              );
              document.getElementById("boton_pago").appendChild(scriptEl);
          //  }
          } else {
            // console.log("Error");
            // this.errorLoadPage = true;
            // this.loadingPagoNiubiz = false;
          }
          // this.utilsService.ocultarCargando();
        },
        (error) => {
          // console.log("Error", error);
          // this.errorLoadPage = true;
          // this.loadingPagoNiubiz = false;
          // this.utilsService.ocultarCargando();
          // this.utilsService.abrirMensajeToken(null, null, null, error);
        }
      );
  }










  ngOnInit(): void {
   // this.obtenerAccesoPago();
  }

}
